<div class="badge" (mouseout)="hovering = false" (mouseover)="mouseOver()">
  <img
    [src]="badge.nftImageThumbUrl"
    [alt]="badge.nftName"
    (load)="imgLoaded = true"
    [ngClass]="{ visible: imgLoaded }"
  />
  <div
    class="hoverContainer"
    [ngClass]="{ visible: hovering }"
    [class.mobile]="deviceType === 'mobile'"
  >
    <ark-button
      [loading]="purchasing"
      [deviceType]="'mobile'"
      (click)="select()"
      type="light"
      size="small"
      >SELECT</ark-button
    >
  </div>
</div>
